import { parseRouteParams } from "best-common-react";
import React, { createContext, useContext } from "react";
import { useLocation } from "react-router";

type SearchParamsContext = {
  params: SearchParams;
};

type RouteParams = {
  venueGuid?: string;
  playId?: string;
  zoom?: string;
  pitchersView?: string;
  mode?: string;
};

type SearchParams = {
  venueGuid?: string;
  playId?: string;
  zoom?: number | string;
  pitchersView?: string;
  mode?: string;
};

const normalizeRouteParams = (params: RouteParams): SearchParams => {
  return {
    venueGuid: params.venueGuid,
    playId: params.playId,
    zoom: !!params.zoom ? (params.zoom === "auto" ? "auto" : parseFloat(params.zoom)) : undefined,
    pitchersView: params.pitchersView,
    mode: params?.mode,
  };
};

const SearchParamsContext = createContext<SearchParamsContext | undefined>(undefined);

const SearchParamsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const params: SearchParams = normalizeRouteParams(parseRouteParams(location.search) as RouteParams);
  return <SearchParamsContext.Provider value={{ params }}>{children}</SearchParamsContext.Provider>;
};

const useSearchParams = (): SearchParamsContext => {
  const searchParamsContext = useContext<SearchParamsContext>(SearchParamsContext);
  if (searchParamsContext === undefined) {
    throw new Error(`useSearchParams must be used within a SearchParamsProvider`);
  }
  return searchParamsContext;
};

export { SearchParamsProvider, useSearchParams };
